<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isSilver === false ? isLoading : false"
    @close="onCloseModal"
  >
    <div slot="body">
      <div v-if="isSilver">
        <img
          class="locker"
          src="../../../assets/img/patterns/lock.svg"
          width="500"
          alt="lock"
        />
        <h1 class="text-center ">شما کاربر نقره ای هستید</h1>
      </div>
      <bita-ibox :is-loading="isLoadingModal" v-if="!isSilver">
        <div v-show="!showResult" slot="body">
          <bita-formgroup title="اطلاعات ذخیره شده" class="row">
            <div class="col-12">
              <div v-if="settingsId" class="d-flex flex-wrap">
                <a
                  class="d-flex border align-items-center py-2 col-md-4 col-sm-6 my-2"
                  style="justify-content: space-between"
                >
                  <span class="d-block" style="max-width: 160px">
                    {{ getSetting.settings_value.name }}
                  </span>
                  <div>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      @click.stop="deleteSettings(getSetting.id)"
                    >
                      <span class="fas fa-times"></span>
                    </button>
                    <button
                      class="btn btn-outline-info btn-sm mr-3"
                      @click.stop="editSettings(getSetting)"
                    >
                      <span class="fas fa-pen-square"></span>
                    </button>
                  </div>
                </a>
              </div>
              <div
                class="row align-items-center justify-content-center px-3 mt-2"
              >
                <bita-select
                  name="settingsId"
                  label="بارهای پیش‌ فرض"
                  input-class="form-control"
                  :data-source="settings"
                  validation-container-class="col-lg-4"
                  data-text-field="settings_value.name"
                  data-value-field="id"
                  v-model="settingsId"
                  @input="onSettings"
                />
                <bita-input
                  id="settingsName"
                  name="state"
                  label="نام(نمایش برای دفعات بعد)"
                  type="text"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  v-model="dataForm.name"
                />
                <div class="d-flex" style="gap: 3px">
                  <bita-bootbutton
                    v-if="settingsId"
                    type="info"
                    class="mt-2"
                    title="ویرایش اطلاعات"
                    @click.native="updateSettings()"
                  />
                  <bita-bootbutton
                    v-else
                    type="info"
                    class="mt-2"
                    title="ذخیره اطلاعات"
                    @click.native="addSettings()"
                  />
                  <!-- <bita-bootbutton
                    v-if="settingsId"
                    type="danger"
                    class="mt-2"
                    title="حذف تنظیمات"
                    @click.native="deleteSetting()"
                  /> -->
                </div>
              </div>
            </div>
          </bita-formgroup>
          <bita-form ref="form">
  
            <div slot="body">
              <div class="row">

                <div class="col-lg-6">
                  <bita-formgroup title="مبدا" class="row ml-lg-1">
                    <bita-select
                      id="originstate"
                      name="state"
                      label="استان"
                      ref="originStateDropDown"
                      rules="required"
                      validation-container-class="col-lg-6 col-md-6 col-sm-6"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="dataForm.origin_state_id"
                      :disabled="dataForm.id && !actionCopy ? true : false"
                    />

                    <Spinner
                      :is-loading="isLoadingCitiesOrgin"
                      class-name="col-lg-6 col-md-6 col-sm-6"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesOrgin === false"
                      name="citiesOrgin"
                      label="شهر"
                      ref="citiesOrginDropDown"
                      rules="required"
                      validation-container-class="col-lg-6 col-md-6 col-sm-6"
                      input-class="form-control"
                      :data-source="citiesOrgin"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="dataForm.origin_id"
                      :disabled="dataForm.id && !actionCopy ? true : false"
                      @change="getCitiesInit"
                    />
                  </bita-formgroup>
                </div>
                <div class="col-lg-6">
                  <bita-formgroup title="مقصد" class="row">
                    <bita-select
                      name="state"
                      label="استان"
                      ref="destinationstateDropDown"
                      rules="required"
                      validation-container-class="col-lg-6 col-md-6 col-sm-6"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="dataForm.destination_state_id"
                      :disabled="dataForm.id && !actionCopy ? true : false"
                    />

                    <Spinner
                      :is-loading="isLoadingCitiesDestination"
                      class-name="col-lg-6 col-md-6 col-sm-6"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesDestination === false"
                      name="citiesDestination"
                      label="شهر"
                      ref="citiesDestinationDropDown"
                      rules="required"
                      validation-container-class="col-lg-6 col-md-6 col-sm-6"
                      input-class="form-control"
                      :data-source="citiesDestination"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="dataForm.destination_id"
                      :disabled="dataForm.id && !actionCopy ? true : false"
                      @change="getCitiesInit"
                    />
                  </bita-formgroup>
                </div>
              </div>

              <bita-formgroup title="نوع بار / بسته‌بندی" class="row">
                <bita-select
                  name="package_id"
                  label="نوع بسته‌بندی"
                  ref="packageDropDown"
                  rules="required"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="packages"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.package_id"
                />

                <bita-select
                  name="categoryLoads"
                  label="دسته بندی نوع بار"
                  rules="required"
                  ref="categoryLoadsDropDown"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="categoryLoads"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.category_loads_id"
                />

                <Spinner
                  :is-loading="isLoadingLoads"
                  class-name="col-lg-4  col-md-6 col-sm-6"
                  styleName="align-self: center;"
                />
                <bita-select
                  v-if="this.isLoadingLoads === false"
                  name="loads"
                  label="نوع بار"
                  ref="loadsDropDown"
                  rules="required"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="loads"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.load_id"
                />
              </bita-formgroup>

              <bita-formgroup title="اطلاعات بار" class="row">
                <bita-select
                  name="salon"
                  label="سالن"
                  ref="salonDropDown"
                  rules="required"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="salons"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.salon_id"
                  :subtitle="commonInputsSubtitle"
                  @change="getPriorities"
                />

                <bita-select
                  v-if="$acl.isBroker || $acl.isSupportUser"
                  name="selectOwnerDropDown"
                  label="فرستنده(صاحب بار)"
                  rules="required"
                  ref="selectOwnerDropDown"
                  id="selectOwnerDropDown"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="propsOwners"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.user_id"
                  :disabled="dataForm.id && !actionCopy ? true : false"
                />
                <bita-select
                  v-if="this.isLoadingCitiesDestination === false"
                  name="customer"
                  label="گیرنده(مشتری)"
                  ref="customerDropDown"
                  rules="required"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="propsCustomers"
                  data-text-field="full_name"
                  data-value-field="id"
                  v-model="dataForm.customer_id"
                  :subtitle="commonInputsSubtitle"
                  
                />
                <bita-input
                  id="tonnage"
                  type="text"
                  name="tonnage"
                  label="حداقل تناژ"
                  rules="required|between:0,9999"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  v-model="dataForm.tonnage"

                />
                <bita-input
                  id="max_tonnage"
                  type="text"
                  name="max_tonnage"
                  label="حداکثر تناژ"
                  :rules="
                    `between:${Number(dataForm.tonnage)},${Number(
                      dataForm.tonnage
                    ) + 2}`
                  "
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  v-model="dataForm.max_tonnage"
                />
                <bita-select
                  id="check_tonnage"
                  name="check_tonnage"
                  label="آیا محدودیت تناژ چک شود؟"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.check_tonnage"
                  rules="required"
                 :disabled="triggeredFromSpecial"
                />

                <bita-select
                  id="force_in_location_for_reserve"
                  name="force_in_location_for_reserve"
                  rules="required"
                  label="موقعیت جغرافیایی راننده موقع رزرو چک شود؟"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.force_in_location_for_reserve"
                 :disabled="triggeredFromSpecial"

                />
                <bita-select
                  id="force_in_location_for_deliver"
                  name="force_in_location_for_deliver"
                  rules="required"
                  label="موقعیت جغرافیایی راننده موقع تحویل چک شود؟"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.force_in_location_for_deliver"
                  :disabled="triggeredFromSpecial"

                />

                <bita-select
                  id="is_good"
                  name="is_good"
                  label=" آیا بار خوب است یا بد؟"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.is_good"
                 :disabled="triggeredFromSpecial"
                />
                <bita-select
                  v-show="!isCarrier_test"
                  id="is_exclusive"
                  name="is_exclusive"
                  label="آیا بار اختصاصی می‌باشد؟"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.is_exclusive"
                 :disabled="triggeredFromSpecial"
                />

                <bita-select
                  id="change_ticket"
                  name="change_ticket"
                  label=" آیا بار نوبت به جا است یا خیر؟"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.change_ticket"
                 :disabled="triggeredFromSpecial"

                />

                 <template v-if="dataForm.salon_id" v-show="!isCarrier_test">
                <div
                  v-show="!isCarrier_test"
                  v-if="!dataForm.is_exclusive > 0"
                  v-for="priority in dataForm.priorities"
                  class="col-lg-4 col-md-6 col-sm-6"
                  :key="priority.key"
                >
                  <bita-input
                    v-show="!isCarrier_test"
                    v-model="priority.value"
                    :label="`اولویت ${priority.key} ${priority.name ? '- ' + priority.name : ''}`"
                    :disabled="dataForm.is_exclusive > 0 && isUpdateMode"
                    name="priority"
                    input-class="form-control"
                  />
                </div>
              </template>

                <bita-input
                  type="text"
                  name="loading_from"
                  label="بارگیری از"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.loading_from"
                />
                <bita-input
                  type="text"
                  name="deliver_to"
                  label="تحویل در"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.deliver_to"
                />
                <bita-input
                  type="text"
                  name="reserve_radius"
                  label="رزرو در شعاع"
                  rules="between:0,1000"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.reserve_radius"
                />
                <bita-textarea
                  name="tools"
                  class="col-12"
                  inputClass="col-12 form-control"
                  place-holder="توضیحات"
                  v-model="dataForm.tools"
                />

                 <bita-input
                  id="request_code"
                  type="number"
                  name="request_code"
                  label="کد بار"
                  rules="numeric"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="col-6 form-control"
                  v-model="dataForm.request_code"
                />

                <bita-textarea
                  name="short_description"
                  class="col-6"
                  inputClass="col-6 form-control"
                  place-holder="توضیحات مهم"
                  rules="max:50"
                  :max-length="50"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  v-model="dataForm.short_description"
                />



              </bita-formgroup>
              <bita-formgroup title="اطلاعات ماشین" class="row">
                <bita-select
                  name="categoryVehicleTypes"
                  label="دسته بندی نوع ماشین"
                  ref="categoryVehicleTypesDropDown"
                  rules="required"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="categoryVehicleTypes"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.category_vehicle_type_id"
                  :disabled="isDisabled"
                />

                <Spinner
                  :is-loading="isLoadingVehicleTypes"
                  class-name="col-lg-4 col-md-6 col-sm-6"
                  styleName="align-self: center;"
                />

                <bita-select
                  v-if="this.isLoadingVehicleTypes === false"
                  name="vehicleTypes"
                  label="نوع ماشین"
                  ref="vehicleTypesDropDown"
                  rules="required"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="vehicleTypes"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.vehicle_type_id"
                  :disabled="isDisabled"
                />
                <bita-input
                  type="text"
                  name="count"
                  label="تعداد"
                  rules="required|between:1,1000"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.count"
                  :disabled="dataForm.id && !actionCopy ? true : false"
                  @change="validateCarrierCount()"
                />
              </bita-formgroup>
              <bita-formgroup title="اطلاعات مالی" class="row">
                <bita-input
                  type="text"
                  name="price"
                  :label="$currencyLabel('قیمت')"
                  :rules="
                    isDisabled ? 'fee' : 'required|fee|min_value:' + cityTariff
                  "
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.price"
                  :subtitle="
                    dataForm.tonnage
                      ? $thousandSeprator(
                          $round(dataForm.price / dataForm.tonnage)
                        ) +
                        ' ' +
                        'تومان بر تناژ '
                      : ''
                  "
                />
                <bita-input
                  type="text"
                  name="netPrice"
                  :label="$currencyLabel('قیمت صافی کل')"
                  :rules="
                    `required|fee|min_value:${cityTariff}|max_value:${dataForm.price ||
                      1}`
                  "
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.net_price"
                  :subtitle="
                    dataForm.tonnage && dataForm.net_price
                      ? 'تنی ' +
                        $thousandSeprator(
                          $round(dataForm.net_price / dataForm.tonnage)
                        ) +
                        ' ' +
                        'تومان '
                      : ''
                  "
                />
                <bita-input
                  type="text"
                  name="loading_fee"
                  :label="$currencyLabel('هزینه بارگیری')"
                  rules="fee|required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.loading_fee"
                  :has-thousand-seprator="true"
                  :disabled="isDisabled"
                />
              </bita-formgroup>
              <bita-formgroup title="زمان" class="row">
                <bita-datepicker
                  class="col-lg-4 col-md-6 col-sm-6"
                  type="time"
                  id="load_start_time"
                  name="load_start_time"
                  label="زمان شروع بارگیری"
                  format="HH:mm:ss"
                  display-format="HH:mm"
                  inputClass="form-control"
                  v-model="dataForm.load_start_time"
                  :disabled="isDisabled"
                />
                <bita-datepicker
                  class="col-lg-4 col-md-6 col-sm-6"
                  type="time"
                  id="load_end_time"
                  name="load_end_time"
                  label="زمان پایان بارگیری"
                  format="HH:mm:ss"
                  display-format="HH:mm"
                  inputClass="form-control"
                  v-model="dataForm.load_end_time"
                  :disabled="isDisabled"
                />
                <bita-datepicker
                  id="expire_at"
                  :rules="dataForm.id ? '' : 'notBeforeToday|required'"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  type="datetime"
                  name="expire_at"
                  label="تاریخ انقضا"
                  inputClass="form-control"
                  v-model="dataForm.expired_at"
                  :disabled="isDisabled"
                  subtitle="زمان مجاز برای رزرو بار تا پایان روز تاریخ انتخاب شده می باشد."
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="jYYYY/jMM/jDD HH:mm:ss"
                />
                <bita-datepicker
                  class="col-lg-4 col-md-6 col-sm-6"
                  type="date"
                  id="loading_at"
                  name="loading_at"
                  :rules="dataForm.id ? '' : 'notBeforeToday|required'"
                  label="تاریخ بارگیری"
                  :clearable="false"
                  inputClass="form-control"
                  v-model="dataForm.loading_at"
                  :disabled="isDisabled"
                />
                <bita-datepicker
                  class="col-lg-4 col-md-6 col-sm-6"
                  type="date"
                  id="delivery_at"
                  :rules="
                    dataForm.id
                      ? ''
                      : '|notBeforeToday|after:@تاریخ بارگیری|required'
                  "
                  name="delivery_at"
                  label="تاریخ تحویل"
                  :clearable="false"
                  inputClass="form-control"
                  v-model="dataForm.delivery_at"
                />
                <bita-input
                  id="tonnage"
                  type="number"
                  name="tonnage"
                  label="حداقل زمان حمل بار(مدت زمان سفر)"
                  rules="required|between:0,9999"
                  validation-container-class="col-lg-4  col-md-6 col-sm-6"
                  input-class="form-control"
                  v-model="dataForm.travel_time"
                  :subtitle="
                    dataForm.travel_time && dataForm.travel_time + ' ساعت'
                  "
                />
                <bita-select
                  v-show="dataForm.job == 1"
                  id="requestJobTypeDropDown"
                  name="requestJobTypeDropDown"
                  label="بازه زمانی ایجاد مجدد"
                  ref="requestJobTypeDropDown"
                  rules=""
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="requestJobType"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.job_type"
                  :disabled="dataForm.id ? true : false"
                />
                <bita-datepicker
                  v-show="dataForm.job_type == 8"
                  class="col-lg-4 col-md-6 col-sm-6"
                  type="date"
                  id="jobValue"
                  name="jobValue"
                  label="تاریخ دلخواه"
                  :clearable="false"
                  inputClass="form-control"
                  v-model="dataForm.job_value"
                  :disabled="dataForm.id ? true : false"
                />
              </bita-formgroup>
              <bita-formgroup title="زمان مراجعه" class="row">
                <bita-datepicker
                  class="col-lg-4 col-md-6 col-sm-6"
                  type="time"
                  id="attend_time"
                  name="attend_time"
                  label="زمان مراجعه"
                  format="HH:mm"
                  display-format="HH:mm"
                  inputClass="form-control"
                  v-model="dataForm.attend_time"
                  :disabled="dataForm.id && !actionCopy? true : false"
                />
                <bita-input
                  type="text"
                  name="attend_cycle"
                  label="دوره زمان مراجعه"
                  rules="between:1,180"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.attend_cycle"
                  :disabled="dataForm.id && !actionCopy?  true : false"
                />
              </bita-formgroup>
              <bita-formgroup title="موقعیت بار" class="row">
                <div class="col-12">
                  <bita-textarea
                    name="address"
                    inputClass="col-12 form-control"
                    place-holder="محل بارگیری"
                    v-model="dataForm.address"
                  />
                </div>
              </bita-formgroup>
            </div>
          </bita-form>
        </div>
        <div v-if="showResult" slot="body">
          <div v-if="carriersError" class="alert alert-danger">
            {{ carriersError }}
          </div>
          <bita-formgroup title=" اطلاعات بار درخواستی" class="row">
            <div
              class="w-100 d-flex flex-column k-gap-1 justify-content-center my-3 text-center"
            >
              <strong class="w-100 text-center" style="font-size: 16px;">
                {{
                  vehicleInformation.parent_name +
                    " / " +
                    vehicleInformation.name
                }}
              </strong>
              <p style="font-size: 14px;">{{ dataForm.count }} خودرو</p>
            </div>
            <div
              class="d-flex align-items-center px-4 justify-content-between w-100 k-gap-2"
            >
              <img src="../../../assets/img/origin.svg" alt="" />
              <div class="divider"></div>
              <img src="../../../assets/img/destinition.svg" alt="" />
            </div>

            <div class="d-flex justify-content-between w-100 px-4 my-2">
              <p>
                {{ originInfo.province_name + " / " + originInfo.city_name }}
              </p>
              <p>
                {{
                  destinationInfo.province_name +
                    " / " +
                    destinationInfo.city_name
                }}
              </p>
            </div>
            <div class="d-flex flex-column">
              <div class="w-100 d-flex align-items-center px-3">
                <div class="divider_line"></div>
                <h3 class="my-2 details-text text-center">جزئیات بار</h3>
                <div class="divider_line"></div>
              </div>
              <div
                class="row px-3 details-container my-3 justify-content-center"
              >
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>دسته بندی نوع بار</span>
                  {{ loadInformation.parent_name }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>نوع بار</span>
                  {{ loadInformation.name }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>مشخصات بسته بندی</span>
                  {{ packageInformation }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>تناژ</span>
                  {{ dataForm.tonnage + " تن " }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>قیمت</span>
                  {{ $thousandSeprator(dataForm.price) + $currencyLabel("") }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>قیمت صافی</span>
                  {{
                    $thousandSeprator(dataForm.net_price) + $currencyLabel("")
                  }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>هزینه بارگیری</span>
                  {{ $thousandSeprator(dataForm.loading_fee) }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>زمان بارگیری</span>
                  {{ loadingtimeInformation }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>تاریخ انقضا</span>
                  {{ $getJalaliDate(dataForm.expired_at) }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>تاریخ بارگیری</span>
                  {{ $getJalaliDate(dataForm.loading_at) }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>تاریخ تحویل</span>
                  {{
                    dataForm.delivery_at
                      ? $getJalaliDate(dataForm.delivery_at)
                      : null
                  }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>نام مشتری</span>
                  {{ customerInformation }}
                </div>
                <div class="d-flex flex-column col-4 ml-0 pl-0 col-md-2 m-2">
                  <span>وضعیت بارنامه</span>
                  {{ waybillInformation }}
                </div>
              </div>
            </div>
          </bita-formgroup>
        </div>
      </bita-ibox>
    </div>
    <div
      slot="footer"
      class="py-3 d-flex flex-column flex-md-row justify-content-between"
    >
      <div
        class="col-12 col-sm-4 mb-2"
        v-if="!propsData.id && !showResult && !isSilver"
      >
        <bita-bootbutton
          type="primary"
          title="مشاهده اطلاعات و ثبت درخواست"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleShowResult()"
        />
      </div>
            <div
        class="col-12 col-sm-4 mb-2"
        v-if="propsData.id && !showResult && !isSilver && actionCopy"
      >
        <bita-bootbutton
          type="primary"
          title="مشاهده اطلاعات و کپی از اطلاعات بار"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleShowResult()"
        />
      </div>
      <div class="col-12 col-md-2 mb-2" v-show="!propsData.id && showResult">
        <bita-bootbutton
          type="primary"
          title="ثبت درخواست"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
          <div class="col-12 col-md-2 mb-2" v-show="propsData.id && showResult && actionCopy">
        <bita-bootbutton
          type="primary"
          title="کپی بار"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
   
      <div class="col-12 col-md-2" v-show="(!propsData.id && showResult) || (showResult && actionCopy)">
        <bita-bootbutton
          type="success"
          title="ویرایش اطلاعات"
          icon="fa fa-check"
          class="w-100 bg-transparent border-0 text-primary"
          @click.native="handleGoBack()"
        />
      </div>
      <div class="col-12 col-md-2" v-if="propsData.id && !actionCopy">
        <bita-bootbutton
          type="primary"
          title="بروزرسانی"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
      <div class="col-12 col-md-2" v-show="!showResult">
        <bita-bootbutton
          type="danger"
          title="بستن"
          icon="fas fa-times"
          class="w-100 bg-transparent border-0 text-danger"
          data-dismiss="modal"
        />
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
import LabelValue from "./LabelValue";

export default {
  components: { Spinner, "label-value": LabelValue },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    packages: {},
    waybillStates: {},
    propsState: { type: Array },
    propsCitiesOrgin: { type: Array },
    propsCitiesDestination: { type: Array },
    propsLoads: { type: Array },
    propsVehicleTypes: { type: Array },
    propsLoadingTimes: { type: Array, default: [] },
    propsCarriers: { type: Array, default: [] },
    propsCustomers: { type: Array, default: [] },
    propsSalons: { type: Array, default: [] },
    propsOwners: {
      type: Array,
    },
    triggeredFromSpecial: {
      type: Boolean,
      default: false,
    },
      actionCopy: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: {
        id: 0,
        count: 0,
        origin_id: 0,
        origin_state_id: 0,
        destination_id: 0,
        destination_state_id: 0,
        vehicle_type_id: 0,
        category_vehicle_type_id: 0,
        salon_id: 0,
        load_id: 0,
        category_loads_id: 0,
        loading_at: "",
        delivery_date: "",
        tools: "",
        user_id: 0,
      },
    },
  },
  data() {
    return {
      requestTypes: [
        { id: 2, name: " اعلان و رزرو بار ( بدون دریافت وجه )" },
        { id: 3, name: "اعلان بار" },
      ],
      requestJobType: [
        { id: 1, name: "۱ روز یک بار" },
        { id: 2, name: "۲ روز یک بار" },
        { id: 3, name: "۳ روز یک بار" },
        { id: 4, name: "۴ روز یک بار" },
        { id: 5, name: "۵ روز یک بار" },
        { id: 6, name: "۶ روز یک بار" },
        { id: 7, name: "۷ روز یک بار" },
        { id: 8, name: "انتخاب تاریخ دلخواه" },
      ],
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {
        carriers: [{ carrier_id: "", count: 0 }],
        priorities: [],
      },
      isSilver: false,
      carriersError: null,
      isLoadingCitiesOrgin: false,
      isLoadingCitiesDestination: false,
      isLoadingLoads: false,
      isLoadingVehicleTypes: false,
      isLoadingModal: false,
      categoryVehicleTypes: [],
      vehicleTypes: [],
      categoryLoads: [],
      loads: [],
      state: [],
      citiesOrgin: [],
      citiesDestination: [],
      waybillStatus: 0,
      showResult: false,
      originInfo: {},
      destinationInfo: {},
      loadInformation: {},
      vehicleInformation: {},
      packageInformation: "",
      loadingtimeInformation: "",
      customerInformation: "",
      waybillInformation: "",
      cityTariff: 0,
      isCarrier_test: false,
      salons: [],
      settingsId: 0,
      settings: [],
    };
  },
  computed: {
    // unUsedCarriers(){
    //   let carrierIds = collect(this.dataForm.carriers).pluck('carrier_id').toArray();
    //   return collect(this.propsCarriers).whereNotIn('id',carrierIds).toArray();
    // },
    isDisabled() {
      // return this.propsData.id && this.propsData.id > 0;
      return false;
    },
    salonID() {
      return this.dataForm.salon_id;
    },
    getSetting() {
      if (!this.settingsId) return {};

      return this.settings.find((item) => item.id == this.settingsId);
    },
    hasWayBill() {
      return Number(this.dataForm.waybill_state_id) == 14;
    },
    hasNotWayBill() {
      return Number(this.dataForm.waybill_state_id) == 15;
    },
    carrierRule() {
      return this.hasWayBill || this.hasNotWayBill ? "" : "";
    },
    waybillNeeded() {
      return (
        // Number(this.dataForm.waybill_state_id) != 16 &&
        this.dataForm.origin_state_id &&
        this.dataForm.destination_state_id &&
        this.dataForm.origin_state_id != this.dataForm.destination_state_id
      );
    },
    isUpdateMode() {
      return this.propsData.id && this.propsData.id > 0;
    },
    commonInputsSubtitle() {
      if (this.isUpdateMode) {
        return "درصورت تغییر برای بارهای تکمیل نشده اعمال می شود";
      }
      // return "این مورد برای تمام درخواست ها در نظر گرفته می‌شود"
      return "";
    },
  },
  mounted() {
    if (this.$acl.roles.find((e) => e === "carrier_test")) {
      this.isCarrier_test = true;
    }
    if (this.$acl.roles.find((e) => e === "silver-subscription")) {
      this.isSilver = true;
    }
    this.getCategoryVehicleTypes();
    this.getCategoryLoads();
    this.getState();
    this.getSettings();
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = {
        ..._data,
        carriers: [{ carrier_id: [], count: 0 }],
        priorities: [],
      };

      this.getCitiesInit();
    },
    propsCitiesOrgin: function(_data) {
      this.citiesOrgin = _data;
    },
    propsCitiesDestination: function(_data) {
      this.citiesDestination = _data;
    },
    propsLoads: function(_data) {
      this.loads = _data;
    },
    propsVehicleTypes: function(_data) {
      this.vehicleTypes = _data;
    },
    "dataForm.waybill_state_id": function(_waybillStateID) {
      if (_waybillStateID == 16) {
        // Inside Province
        this.dataForm.carrier_id = null;
        let dropDowns = ["carrierDropDown", "carrierMultiSelect"];
        this.clearKendos(dropDowns);
      }
    },
    "dataForm.origin_state_id": function(e) {
      this.getCityOrgin(e);
      this.setWaybillStateAsInProvince();
    },
    "dataForm.destination_state_id": function(e) {
      this.getCityDestination(e);
      this.setWaybillStateAsInProvince();
    },
    "dataForm.category_loads_id": function(e) {
      this.getLoads(e);
    },
    "dataForm.category_vehicle_type_id": function(e) {
      this.getVehicleTypes(e);
    },
  },
  methods: {
    setInitialData(_data) {
      this.reset();
      this.dataForm = {};
      this.isLoadingModal = true;
      if (_data.origin_id && _data.origin_state_id)
        this.getCityOrgin(_data.origin_state_id);
      if (_data.category_loads_id && _data.load_id)
        this.getLoads(_data.category_loads_id);
      if (_data.category_vehicle_type_id && _data.vehicle_type_id)
        this.getVehicleTypes(_data.category_vehicle_type_id);
      const vm = this;
      setTimeout(function() {
        vm.dataForm = {
          ..._data,
          job: 0,
          request_type: 2,
          carriers: [{ carrier_id: "", count: 0 }],
          priorities: [],
        };
        vm.isLoadingModal = false;
      }, 1000);
    },
    validateCarrierCount() {
      let carriersCount = collect(this.dataForm.carriers).sum("count");
      if (carriersCount && carriersCount > this.dataForm.count) {
        this.carriersError =
          "تعداد بار تقسیم شده بین باربری ها از تعداد کل بیشتر است";
        return;
      }
      this.carriersError = null;
    },
    removeCarrier(carrier, index) {
      this.$delete(this.dataForm.carriers, index);
    },
    addCarrier() {
      this.dataForm.carriers.push({ carrier_id: [], count: 0 });
    },
    changeCarrierStatus() {
      this.dataForm.carrier_id = null;
      let dropDowns = ["carrierDropDown", "carrierDropDown"];
      this.clearKendos(dropDowns);
    },
    setWaybillStateAsInProvince() {
      var _this = this;
      if (this.dataForm.origin_state_id == this.dataForm.destination_state_id) {
        let dropDowns = ["carrierStatusDropDown"];
        this.clearKendos(dropDowns);
        _this.dataForm.waybill_state_id = 16;
      }
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
        if (this.dataForm.waybill_state_id === 'null') {
        this.dataForm.waybill_state_id = null;
      }
          this.showResult = false;
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    handleShowResult() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoadingModal = true;
          const _this = this;
          this.getOriginFromCollect(this.dataForm.origin_id);
          this.dataForm.destination_id
            ? this.getDestinationFromCollect(this.dataForm.destination_id)
            : false;
          this.dataForm.load_id
            ? this.getLoadFromCollect(this.dataForm.load_id)
            : false;
          this.dataForm.vehicle_type_id
            ? this.getVehicleTypeFromCollect(this.dataForm.vehicle_type_id)
            : false;
          this.dataForm.loading_time_id
            ? this.getLoadingTimeFromCollect(this.dataForm.loading_time_id)
            : false;
          this.dataForm.customer_id
            ? this.getCustomerFromCollect(this.dataForm.customer_id)
            : false;
          this.dataForm.salon_id
            ? this.getSalonFromCollect(this.dataForm.salon_id)
            : false;
          this.dataForm.waybill_state_id
            ? this.getWaybillFromCollect(this.dataForm.waybill_state_id)
            : false;
          this.dataForm.package_id
            ? this.getPackageFromCollect(this.dataForm.package_id)
            : false;
          setTimeout(function() {
            _this.isLoadingModal = false;
            _this.showResult = true;
          }, 500);
        }
      });
    },
    handleGoBack() {
      this.showResult = !this.showResult;
    },
    reset() {
      this.deleteSetting();

      this.setDefaultDataform();
      this.$refs.form.reset();
    },
    getState() {
      this.$persistClient("get", "cities?filter[province]=0")
        .then((res) => {
          this.state = res.data;
        })
        .finally(() => {});
    },
    getCityOrgin(stateId) {
      this.isLoadingCitiesOrgin = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesOrgin = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesOrgin = false;
        });
    },
    getCityDestination(stateId) {
      this.isLoadingCitiesDestination = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesDestination = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesDestination = false;
        });
    },
    getCategoryVehicleTypes() {
      this.$persistClient("get", `vehicle-types?filter[parent]=0`)
        .then((res) => {
          this.categoryVehicleTypes = res.data;
        })
        .finally(() => {});
    },
    getVehicleTypes(categoryId) {
      this.isLoadingVehicleTypes = true;

      this.$persistClient("get", `vehicle-types?filter[parent]=${categoryId}`)
        .then((res) => {
          this.vehicleTypes = res.data;
        })
        .finally(() => {
          this.isLoadingVehicleTypes = false;
        });
    },
    getCategoryLoads() {
      this.$persistClient("get", `loads?filter[parentItem]=0`)
        .then((res) => {
          this.categoryLoads = res.data;
        })
        .finally(() => {});
    },
    getLoads(categoryId) {
      this.isLoadingLoads = true;

      this.$persistClient("get", `loads?filter[parentItem]=${categoryId}`)
        .then((res) => {
          this.loads = res.data;
        })
        .finally(() => {
          this.isLoadingLoads = false;
        });
    },
    clearKendos(_refs) {
      for (let ref of _refs) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
    },
    onCloseModal(e) {
      this.reset();
    },
    getOriginFromCollect(originCityId) {
      const state = collect(this.state);
      const originCity = collect(this.citiesOrgin);
      const originCityValue = originCity.firstWhere("id", Number(originCityId));
      this.originInfo.city_name = originCityValue
        ? originCityValue.name
        : "---";
      const search = state.firstWhere("id", originCityValue.parent_id);
      this.originInfo.province_name = search ? search.name : "---";
      return this.originInfo;
    },
    getDestinationFromCollect(destinationCityId) {
      const state = collect(this.state);
      const destinationCity = collect(this.citiesDestination);
      const destinationCityValue = destinationCity.firstWhere(
        "id",
        Number(destinationCityId)
      );
      this.destinationInfo.city_name = destinationCityValue
        ? destinationCityValue.name
        : "---";
      const search = state.firstWhere("id", destinationCityValue.parent_id);
      this.destinationInfo.province_name = search ? search.name : "---";
      return this.destinationInfo;
    },
    getLoadFromCollect(loadId) {
      const parentLoad = collect(this.categoryLoads);
      const load = collect(this.loads);
      const loadValue = load.firstWhere("id", Number(loadId));
      this.loadInformation.name = loadValue ? loadValue.name : "---";
      const search = parentLoad.firstWhere("id", loadValue.parent_id);
      this.loadInformation.parent_name = search ? search.name : "---";
      return this.loadInformation;
    },
    getPackageFromCollect(packageId) {
      const packageData = collect(this.packages);
      const search = packageData.firstWhere("id", Number(packageId));
      this.packageInformation = search ? search.name : "---";
      return this.packageInformation;
    },
    getVehicleTypeFromCollect(vehicleTypeId) {
      const parentVehicleTypes = collect(this.categoryVehicleTypes);
      const vehicleTypes = collect(this.vehicleTypes);
      const vehicleTypesValue = vehicleTypes.firstWhere(
        "id",
        Number(vehicleTypeId)
      );
      this.vehicleInformation.name = vehicleTypesValue
        ? vehicleTypesValue.name
        : "---";
      const search = parentVehicleTypes.firstWhere(
        "id",
        vehicleTypesValue.parent_id
      );
      this.vehicleInformation.parent_name = search ? search.name : "---";
      return this.vehicleInformation;
    },
    getLoadingTimeFromCollect(loadingTimeId) {
      const parentLoadingTime = collect(this.propsLoadingTimes);
      const search = parentLoadingTime.firstWhere("id", Number(loadingTimeId));
      this.loadingtimeInformation = search ? search.name : "---";
      return this.loadingtimeInformation;
    },
    getCustomerFromCollect(customerId) {
      const parentCustomer = collect(this.propsCustomers);
      const search = parentCustomer.firstWhere("id", Number(customerId));
      this.customerInformation = search ? search.name : "---";
      return this.customerInformation;
    },
    getSalonFromCollect(salonId) {
      const parentSalon = collect(this.propsSalons);
      const search = parentSalon.firstWhere("id", Number(salonId));
      this.salonInformation = search ? search.name : "---";
      return this.salonInformation;
    },
    getWaybillFromCollect(waybillId) {
      const parentWaybill = collect(this.waybillStates);
      const search = parentWaybill.firstWhere("id", Number(waybillId));
      this.waybillInformation = search ? search.name : "---";
      return this.waybillInformation;
    },
    setDefaultDataform() {
      this.dataForm = {
        job: 0,
        request_type: 2,
        carriers: [{ carrier_id: "", count: 0 }],
      };
      this.cityTariff = 0;
    },
    async getCitiesInit() {
      const salon_id = this.dataForm.salon_id;
      this.dataForm.salon_id = null;
      const origin_city_id = this.dataForm.origin_id;
      const destination_city_id = this.dataForm.destination_id;
      if (!this.isDisabled) this.dataForm.salon_id = null;

      if (!!origin_city_id && !!destination_city_id) {
        await this.$persistClient(
          "get",
          `cities/request-init?origin_city_id=${this.dataForm.origin_id}&destination_city_id=${this.dataForm.destination_id}`
        ).then((res) => {
          const data = res.data.data;
          this.cityTariff = data.tariff ?? 0;
          this.salons = [];

          data.terminals.forEach((terminal) => {
            this.salons.push(...terminal.salons);
          });

          if (this.dataForm.id && salon_id) {
            this.getPriorities(salon_id);
          }
        });
      }

      this.dataForm.salon_id = salon_id;
    },
  
 async getPriorities(salonId) {
  const salon = this.salons.find(el => el.id == salonId);

  this.dataForm.priorities = [];

  if (this.dataForm._priorities) {
    for (const [key, value] of Object.entries(this.dataForm._priorities)) {
      const [, newKey] = key.split("_");
      
      const name = salon.prioritiesNames?.[salon.priorities.indexOf(Number(newKey))] ?? "";

      this.dataForm.priorities.push({
        key: Number(newKey),
        value: value,
        name: name
      });
    }
  } else if (salon?.priorities?.length) {
    salon.priorities.forEach((priorityKey, index) => {
      this.dataForm.priorities.push({
        key: priorityKey,
        value: "",
        name: salon.prioritiesNames?.[index] ?? ""
      });
    });
  }

  if (this.triggeredFromSpecial) {
    this.resetSpecialFields();
    if (salon?.view_config) {
      this.fillSpecialInputs(salon);
    }
  }
},


    getSettings() {
      this.isLoadingModal = true;
      this.$persistClient(
        "get",
        "requests/settings?settings_type=2",
        this.dataForm
      )
        .then((res) => {
          this.settings = res.data;
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    fillSpecialInputs(salon) {
      if (!salon || !salon.view_config) {
        return;
      }
      const view_config = salon?.view_config;

      Object.keys(view_config).forEach((configKey) => {
        const value = view_config[configKey];

        if (value !== undefined && value !== null) {
          this.dataForm[configKey] = value;
        }
      });
    },
    resetSpecialFields() {
      const specialFields = [
        "force_in_location_for_reserve",
        "force_in_location_for_deliver",
        "is_good",
        "check_tonnage",
        "is_exclusive",
        "change_ticket",
      ];

      specialFields.forEach((field) => {
        this.dataForm[field] = null;
      });
    },
    addSettings() {
      if (this.dataForm.name) {
        this.isLoadingModal = true;
        this.$persistClient("post", "requests/settings", {
          settings_type: "2",
          settings_value: this.dataForm,
        })
          .then((res) => {
            this.dataForm.name = "";
            this.getSettings();
            this.$izitoast("success", "عملیات موفق", res.data.messages);
          })
          .finally(() => {
            this.isLoadingModal = false;
          });
      }
    },
    editSettings(data) {
      this.settingsId = data.id;
      this.dataForm = { ...data.settings_value };
      this.getCitiesInit();
    },
    updateSettings() {
      if (this.dataForm.name) {
        this.isLoadingModal = true;
        this.$persistClient("patch", "requests/settings/" + this.settingsId, {
          settings_type: "2",
          settings_value: this.dataForm,
        })
          .then((res) => {
            this.dataForm.name = "";
            this.settingsId = 0;
            this.getSettings();
            this.$izitoast("success", "عملیات موفق", res.data.messages);
          })
          .finally(() => {
            this.isLoadingModal = false;
          });
      }
    },
    onSettings() {
      const settingsValue = this.getSetting.settings_value;
      this.dataForm = { ...settingsValue };

      this.dataForm.name = "";
      this.getCitiesInit();
    },
    deleteSettings(id) {
      this.isLoadingModal = true;
      this.$persistClient("delete", `requests/settings/${id}`)
        .then((res) => {
          this.settingsId = 0;

          this.getSettings();
          this.$izitoast("success", "عملیات موفق", res.data.messages);
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    deleteSetting() {
      this.dataForm = {
        carriers: [{ carrier_id: "", count: 0 }],
        priorities: [],
      };

      this.settingsId = 0;
    },
  },
};
</script>
<style scoped>
.lock {
  pointer-events: none;
  filter: blur(2px);
  backdrop-filter: blur(2px);
}
.divider {
  width: 100%;
  height: 1px;
  background: transparent;
  border: 1px dashed #26262678;
}
.divider_line {
  width: 100%;
  height: 1px;
  background: transparent;
  border: 1px solid #c6c6c678;
}
.details-container span {
  color: #7a7a7a !important;
}
.locker {
  z-index: 9999999999;
  display: block;
  margin: auto;
  width: 25%;
  filter: none;
  backdrop-filter: none;
  opacity: 0.8;
}
.details-text {
  flex: 1 0 100px;
}
</style>

